import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export interface SearchFilterEndAdornmentClasses {
	/** styles applied to the root element */
	root: string;
}

export const getSearchFilterEndAdornmentClassesUtilityClass = (slot: string) =>
	generateUtilityClass('SearchFilterEndAdornment', slot);

export const searchFilterEndAdornmentClasses = generateUtilityClasses(
	'SearchFilterEndAdornment',
	['root'],
);
export default searchFilterEndAdornmentClasses;
